import React, { useEffect, useRef } from "react";

const ScrollProgressBar = () => {
  const barRef = useRef(null);

  useEffect(() => {
    let ticking = false;

    const updateBar = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (barRef.current && totalHeight > 0) {
        const progress = Math.min(Math.max((window.scrollY / totalHeight), 0), 1);
        barRef.current.style.transform = `scaleX(${progress})`;
      }
      ticking = false;
    };

    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(updateBar);
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    updateBar();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className="fixed top-0 left-0 w-full h-[3px] z-[9999] bg-transparent pointer-events-none"
      aria-hidden="true"
    >
      <div
        ref={barRef}
        className="h-full w-full bg-gradient-to-r from-[#00D2FF] to-[#3A7BD5] origin-left shadow-sm"
        style={{ transform: "scaleX(0)", willChange: "transform" }}
      />
    </div>
  );
};

export default ScrollProgressBar;
